var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.override.class || ['quality', _vm.pill.key],attrs:{"title":_vm.title}},[_vm._v(_vm._s(_vm.override.text || _vm.pill.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }